
































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { loadReservationReviewAction } from "../store/reservation/action-types";
import { isSystemCourseGetter } from "../store/reservation/getter-types";

const ReservarionModule = namespace("reservation");
@Component
export default class ReservationRedivInfodiv extends Vue {
  @ReservarionModule.Action(loadReservationReviewAction)
  loadReservationReview: any;

  @ReservarionModule.State("reviewData") reviewData: any;
  @ReservarionModule.Getter(isSystemCourseGetter)
  isSystemCourse: any;

  showMore = false;

  created() {
    this.loadReservationReview();
  }

  onShowMore() {
    this.showMore = true;
  }
}
